import getHeaders from "./get-headers";
import getURL from "./get-url";

const post = async (url, session, params, contentType = 'json', authorized = true) => {
    const response = await fetch(getURL(url), {
        method: 'POST',
        headers: getHeaders(session),
        body: params ? JSON.stringify(params) : null
    });

    if (!response.ok) {
        const { name, message } = await response.json();
        throw new Error([name, message].filter(x => x).join(': '));
    }

    let data = null;
    if (contentType === 'blob') {
        data = await response.blob();
    }
    else if (contentType === 'text') {
        data = await response.text();
    }
    else {
        data = await response.json();
    }

    return data;
}
export default post;
